'use client'

import { useEffect, useRef } from 'react'

export function ReadingProgressBar() {
    const barRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const bar = barRef.current
        if (!bar) return

        let ticking = false

        function update() {
            const scrollTop = window.scrollY
            const scrollHeight = document.documentElement.scrollHeight - window.innerHeight

            const ratio = scrollHeight > 0 ? Math.max(0, Math.min(scrollTop / scrollHeight, 1)) : 0

            if (bar) bar.style.transform = `scaleX(${ratio})`
            ticking = false
        }

        function onScroll() {
            if (!ticking) {
                ticking = true
                requestAnimationFrame(update)
            }
        }

        update()
        window.addEventListener('scroll', onScroll, { passive: true })
        window.addEventListener('resize', onScroll)

        return () => {
            window.removeEventListener('scroll', onScroll)
            window.removeEventListener('resize', onScroll)
        }
    }, [])

    return (
        <div aria-hidden className="pointer-events-none fixed inset-x-0 top-0 z-60 h-1">
            <div
                ref={barRef}
                className="h-full origin-left bg-primary-400 will-change-transform"
                style={{ transform: 'scaleX(0)' }}
            />
        </div>
    )
}
